import { sortOrderType } from '@/utils';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const HierarchyLabelModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  sortOrder: z.number().int().min(1),
  name: z.string().min(1).max(16),
  isUsedForCommentOrWorkflow: z.boolean(),
});

export const HierarchyLabelsModel = HierarchyLabelModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const HierarchyLabelFormSchema = HierarchyLabelModel.pick({
  name: true,
  isUsedForCommentOrWorkflow: true,
});

export const UpdateHierarchyLabelSortOrderParamsSchema =
  HierarchyLabelModel.pick({
    id: true,
  })
    .extend({
      sortOrder: sortOrderType,
    })
    .array();
